module.exports = __webpack_public_path__ + "img/F4.c505e1bd.png";